import { testimonials } from '@/mocks/home';

export default function Testimonials() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            用户好评如潮
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            听听真实用户怎么说，mogu视频已经帮助数百万用户提升时尚品味
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/70"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: item.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center text-accent-500">
                    <i className="ri-star-fill text-sm"></i>
                  </div>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                &ldquo;{item.content}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                  {item.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}